SubmitInput.propTypes = {
  text: PropTypes.string,
};

SubmitInput.defaultProps = {
  text: "Submit",
};

export default function SubmitInput({ text }) {
  return (
    <div className={"field field-submit"}>
      <div className={"control"}>
        <button className="submit">{text}</button>
      </div>
    </div>
  );
}
